import ApiService from "../../commons/services/ApiService";
import CompanyAPI from "../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();

export default class CustomerRewardsAPI {

    URI_V1 = "/v1/customer-rewards"

    getPointsBalance = async (whatsapp: any) => {
        return await apiService.get(`${this.URI_V1}/points-balance?whatsapp=${whatsapp}&companyId=${companyAPI.getCompanyManagment().id}`);
    };

    getPointsUsableDays = async (serviceId: any) => {
        return await apiService.get(`${this.URI_V1}/points-usable-days?serviceId=${serviceId}&companyId=${companyAPI.getCompanyManagment().id}`);
    };
}
